/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  IShelfListMethods,
  ShelfListService,
  ICreateShelfMethods,
  CreateShelfService,
  IPrintShelfShelfMethods,
  PrintShelfService,
} from "./components";

export type ShelfPageAgent = IHeaderMethods &
  ISettingsMethods &
  IStaticPageContentMethods &
  IShelfListMethods &
  ICreateShelfMethods &
  IPrintShelfShelfMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new SettingsService(),
    new ShelfListService(),
    new CreateShelfService(),
    new PrintShelfService(),
  ];
};

export const getAgent = () => {
  return createAgent<ShelfPageAgent>({
    plugins: getPlugins(),
  });
};
